module.exports = "/static/assets/27eb5fe70cedf28176edc100ba2225e3.png";